import {SegmentState} from './segment.model';
import {SegmentSearchFilterModel} from './list/search/search-filter.model';


export const TABLE_COLUMNS_TO_DISPLAY_NAME = {
  id: 'ID',
  clientSideId: 'Clientside ID',
  name: 'Name',
  sharedAccounts: 'Shared Accounts',
  reachXpredict: 'Reach xpredict',
  reach: 'Merged reach',
  reachNarthaPure: 'Reach Nartha pure',
  reachNarthaConverted: 'Reach nartha converted',
  pubmatic: 'Pubmatic reach',
  ttd: 'TTD reach',
  yoc: 'YOC reach',
  activeAgentEmetriq: 'Active Agent Emetriq reach',
  activeAgentBcn: 'Active Agent BCN reach',
  activeAgentIqd: 'Active Agent IQD reach',
  activeAgentNetpoint: 'Active Agent Netpoint reach',
  activeAgentQuarterMedia: 'Active Agent Quarter Media reach',
  activeAgentRnd: 'Active Agent RND reach',
  activeAgentTargetVideo: 'Active Agent Target Video',
  adform: 'Adform Reach',
  adobe: 'Adobe Reach',
  xandr: 'Xandr Reach',
  googleDbmEmetriqAdvertiser: 'Google DBM Emetriq Advertiser reach',
  googleDbm: 'Google DBM reach',
  googleDdp: 'Google DDP reach',
  googleDfp: 'Google DFP reach',
  mainType: 'Main type',
  subType: 'Sub type',
  audienceType: 'Audience type',
};

export interface SegmentListConfig {
  tableColumnsToPresent: string[],
  defaultTableColumns: string[],
  allAvailableTableColumns: string[],
  filtersToPresent: string[],
  defaultFilterValues: SegmentSearchFilterModel,
  showFilterButtons: boolean,
  segmentDetailsTabsToPresent: string[],
  segmentDetailsButtonsToPresent: string[]
}

export const ActiveSegmentListConfig: SegmentListConfig = {
  tableColumnsToPresent: ['select'],
  defaultTableColumns: ['id', 'clientSideId', 'name', 'sharedAccounts',
    'reachNarthaPure', 'reachNarthaConverted'],
  allAvailableTableColumns: [...Object.keys(TABLE_COLUMNS_TO_DISPLAY_NAME)],
  filtersToPresent: ['segmentIds', 'name', 'clientSideId', 'mainType', 'subType', 'audienceType', 'category', 'accounts', 'ttdCompliance'],
  defaultFilterValues: <SegmentSearchFilterModel>{
    global: '',
    segmentIds: undefined,
    name: '',
    partnerId: undefined,
    ttdCompliance: undefined,
    clientSideId: '',
    segmentMainTypes: [],
    segmentSubTypes: [],
    segmentAudienceTypes: [],
    category: [],
    accounts: [],
    state: SegmentState.ACTIVE,
    applyFilterToChildren: true,
    taxonomies: []
  },
  showFilterButtons: true,
  segmentDetailsTabsToPresent: ['accounts', 'validations', 'auditLogs'],
  segmentDetailsButtonsToPresent: ['edit', 'delete']
};
export const HierarchicalActiveSegmentListConfig: SegmentListConfig = {
  tableColumnsToPresent: ['select'],
  defaultTableColumns: ['id', 'name', 'sharedAccounts', 'reachNarthaPure', 'reachNarthaConverted'],
  allAvailableTableColumns: [...Object.keys(TABLE_COLUMNS_TO_DISPLAY_NAME)],
  filtersToPresent: ['segmentIds', 'name', 'clientSideId', 'mainType', 'subType', 'audienceType', 'category', 'accounts', 'taxonomies'],
  defaultFilterValues: <SegmentSearchFilterModel>{
    global: '',
    segmentIds: undefined,
    name: '',
    partnerId: undefined,
    clientSideId: '',
    segmentMainTypes: [],
    segmentSubTypes: [],
    segmentAudienceTypes: [],
    category: [],
    accounts: [],
    state: SegmentState.ACTIVE,
    taxonomies: []
  },
  showFilterButtons: true,
  segmentDetailsTabsToPresent: ['accounts', 'validations', 'auditLogs'],
  segmentDetailsButtonsToPresent: ['edit', 'delete']
};

export const DeletedSegmentListConfig: SegmentListConfig = {
  tableColumnsToPresent: ['select'],
  defaultTableColumns: ['select', 'id', 'name', 'mainType', 'subType', 'audienceType', 'category'],
  allAvailableTableColumns: ['select', 'id', 'name', 'mainType', 'subType', 'audienceType', 'category'],
  filtersToPresent: ['segmentIds', 'name', 'mainType', 'subType', 'audienceType', 'category'],
  defaultFilterValues: <SegmentSearchFilterModel>{
    global: '',
    segmentIds: undefined,
    name: '',
    partnerId: undefined,
    clientSideId: '',
    segmentMainTypes: [],
    segmentSubTypes: [],
    segmentAudienceTypes: [],
    category: [],
    accounts: [],
    state: SegmentState.DELETED,
    applyFilterToChildren: true,
    taxonomies: []
  },
  showFilterButtons: false,
  segmentDetailsTabsToPresent: ['auditLogs'],
  segmentDetailsButtonsToPresent: []
};
